module.exports = "https://cdn.realtymogul.com/static/media/HP_card_trails_at_lakeside.562ccd66.jpg";